import { Route, Redirect } from "react-router-dom";
import { IPublicRoute } from "./PublicRoute";

const PublicRoute: React.FC<IPublicRoute.IProps> = ({
  children,
  isAuthenticated,
  ...rest
}) => {
  return (
    <Route
      {...rest}
      render={({ location }) =>
        !isAuthenticated ? (
          children
        ) : (
          <Redirect
            to={{
              pathname: "/overview",
              state: { from: location },
            }}
          />
        )
      }
    />
  );
};

export { PublicRoute };
